import {createContext} from "react";

import {ShapeType, TLevelObject} from "@repo/shared";

import {InstanceTypeData} from "./GameStateProvider";

export interface GameStateContextType {
  add: (objects: TLevelObject[]) => number[];
  getAllInstances: () => TLevelObject[];
  getSelectedInstances: () => TLevelObject[];
  clear: () => void;
  getInstanceType: (type: ShapeType) => InstanceTypeData;
  getInstanceTypes: (
    filterFn?: (type: ShapeType) => boolean,
  ) => InstanceTypeData[];
  getFullInstanceTypes: (
    filterFn?: (type: ShapeType) => boolean,
  ) => [ShapeType, InstanceTypeData][];
}

export const GameStateContext = createContext<GameStateContextType | undefined>(
  undefined,
);
